import { arrayOf, objectOf } from "@altostra/type-validations";
import { maybeNumber, number, string } from "@altostra/type-validations/lib/primitives";

import { isCreativeVariantWarning } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants";
import type {
  DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult,
} from "./types";

const isPutVariant = objectOf<
  PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult["variant"]
>({
  variant_id: number,
  creative: string,
  compatible_base_creative_campaign_ids: arrayOf(string),
  replacement_variant_id: maybeNumber,
});

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult>({
    variant: isPutVariant,
    warnings: arrayOf(isCreativeVariantWarning),
  });

export const isDeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult =
  objectOf<DeleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdResult>({
    deleted_variant_id: string,
  });
